import React from 'react';
import { makeStyles } from '@material-ui/core';

export default function MappingPage(props) {
    const classes = useStyles();

    return <div className={classes.container}>
       Configure the mappings here....

    </div>
}

const useStyles = makeStyles({

});